module.exports = __webpack_public_path__ + "static/media/ibd_shoulder1.e68484cf.png";